import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { useForgotPasswordMutation } from './Api';
import '../../Common.css';

const ForgotPassword = () => {

    const navigate = useNavigate()

    const [forgotPasswordApi, { isLoading }] = useForgotPasswordMutation()

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                "Enter valid email")
            .email('Email is invalid')
            .trim(),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    //dark mode
    useEffect(() => {
        const theme = localStorage.getItem('theme')
        if (theme == 'dark') {
            const darkMode = true
            document.documentElement.classList.toggle("app-skin-dark", darkMode);
        }
    }, []);


    const onSubmit = async (data) => {
        try {
            const forgotPasswordApiResponse = await forgotPasswordApi(data)

            if (forgotPasswordApiResponse?.data?.success) {

                ToastrService.success(forgotPasswordApiResponse.data.message);
                reset()
                navigate('/')

            } else {
                ToastrService.error(forgotPasswordApiResponse.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }

    };

    return (
        <div>
            {isLoading ? <Loader /> :
                <div className="auth-minimal-wrapper">
                    <div className="auth-minimal-inner">
                        <div className="minimal-card-wrapper">
                            <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                                <div class="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                                    <img src='images/logo/logoicon.ico' alt="" class="img-fluid" />
                                </div>
                                <div className="card-body p-sm-5">
                                    <h2 className="fs-20 fw-bolder mb-4">Forgot Password</h2>
                                    <p class="fs-12 fw-medium text-muted">Enter your email and a reset link will sent to you, let's access our the best recommendation for you.</p>
                                    <form onSubmit={handleSubmit(onSubmit)} className="w-100">
                                        <div className="mt-2">
                                            <input
                                                type="text"
                                                id="mail"
                                                name='email'
                                                placeholder='Email'
                                                {...register('email')}
                                                className="form-control"
                                            />
                                            {errors.email && (
                                                <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.email.message}
                                                </p>
                                            )}
                                        </div>
                                        <div className="mt-2">
                                            <button type="submit" className="btn btn-lg btn-primary w-100">
                                                Submit
                                            </button>
                                        </div>
                                        <div className="mt-2 text-center fs-12">
                                            <span className="text-muted">Remember your password? </span>
                                            <span className='text-primary cursor-pointer'
                                                onClick={() => navigate('/')}
                                            >
                                                Back to Login
                                            </span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default ForgotPassword
